<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-06-111"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <!-- タイトル -->
        <label slot="title">
          {{ $t("label.location.mapxusManage") }}
        </label>
        <!-- 登録ボタン -->
        <narrow-down @click="updateStatus" v-auth="{ auth: '010223' }" slot="create">
          {{ $t("button.common.data.create") }}
        </narrow-down>

        <!-- キャンセルボタン -->
        <sp-smart-button @click="mapxusManage" slot="cancel">
          {{ $t("button.common.cancel") }}
        </sp-smart-button>
      </head-title>
    </el-row>

    <!--  body start  -->
    <div slot="body">

      <div>
        <el-form class="info-area" :rules="rules" :model="dataInfo" ref="formRef" label-position="left">

          <!-- データプラットフォーム利用情報 -->
          <div class="sub-title">
            {{ $t("label.location.dataPlatformUsageInformation") }}
          </div>
          <hr class="delimiter" />

          <!-- 会社名 -->
          <el-form-item
            class="title_item   m-bottom-24"
            prop="customerName"
            label-width="220px"
            :label="$t('label.location.customerName')"
          >
            <el-input
              maxlength="20"
              class="show-word-limt-input-padding-right-52"
              style="width: 356px"
              show-word-limit
              v-model="dataInfo.customerName"
              :placeholder="$t('label.location.customerName')"
            >
            </el-input>
          </el-form-item>

          <!-- customerID -->
          <el-form-item
            class="title_item   m-bottom-24"
            prop="customerId"
            label-width="220px"
            :label="$t('label.location.customerId')"
          >
            <el-input
              maxlength="8"
              class="show-word-limt-input-padding-right-52"
              style="width: 200px"
              v-model="dataInfo.customerId"
              show-word-limit
              :placeholder="$t('label.location.customerId')"
            >
            </el-input>
          </el-form-item>

          <!-- サブスクリプションキー -->
          <el-form-item
            class="title_item   m-bottom-24"
            prop="subscriptionKey"
            label-width="220px"
            :label="$t('label.location.subscriptionKey')"
          >
            <el-input
              maxlength="32"
              class="show-word-limt-input-padding-right-52"
              style="width: 356px"
              v-model="dataInfo.subscriptionKey"
              show-word-limit
              :placeholder="$t('label.location.subscriptionKey')"
            >
            </el-input>
          </el-form-item>


          <!-- mapxus SDK利用情報 -->
          <div class="sub-title m-top-60">
            {{ $t("label.location.mapxusSDKUsageInformation") }}
          </div>
          <hr class="delimiter" />
          <div class="sdk-content-style">
            <!-- header title -->
            <div class="dis-flex">
              <div style="width: 220px;" class="sub-color m-bottom-24">
                {{ $t("label.location.mapxusSDK") }}
              </div>
              <div style="width:728px;" class="dis-flex m-bottom-24">
                <div class="width-50 sub-color">
                  {{ $t("label.location.appID") }}
                </div>
                <div style="margin-left: 10px;" class="sub-color">
                   {{ $t("label.location.secret") }}
                </div>
              </div>
            </div>

            <!-- Web -->
            <div class="dis-flex">
              <!-- appID -->
              <el-form-item
                class="title_item   m-bottom-24"
                prop="webAppId"
                label-width="220px"
                :label="$t('label.location.web')"
              >
                <el-input
                  maxlength="32"
                  class="show-word-limt-input-padding-right-52"
                  style="width: 356px"
                  v-model="dataInfo.webAppId"
                  show-word-limit
                  :placeholder="$t('label.location.appID')"
                >
                </el-input>
              </el-form-item>

              <!-- Secret -->
              <el-form-item
                class="title_item m-bottom-24 m-left-16"
                prop="webSecret"
              >
                <el-input
                  maxlength="32"
                  class="show-word-limt-input-padding-right-52"
                  style="width: 356px"
                  v-model="dataInfo.webSecret"
                  show-word-limit
                  :placeholder="$t('label.location.secret')"
                >
                </el-input>
              </el-form-item>
            </div>

            <!-- Android -->
            <div class="dis-flex">
              <!-- appID -->
              <el-form-item
                class="title_item   m-bottom-24"
                prop="androidAppId"
                label-width="220px"
                :label="$t('label.location.android')"
              >
                <el-input
                  maxlength="32"
                  class="show-word-limt-input-padding-right-52"
                  style="width: 356px"
                  v-model="dataInfo.androidAppId"
                  show-word-limit
                  :placeholder="$t('label.location.appID')"
                >
                </el-input>
              </el-form-item>

              <!-- Secret -->
              <el-form-item
                class="title_item m-bottom-24 m-left-16"
                prop="androidSecret"
              >
                <el-input
                  maxlength="32"
                  class="show-word-limt-input-padding-right-52"
                  style="width: 356px"
                  v-model="dataInfo.androidSecret"
                  show-word-limit
                  :placeholder="$t('label.location.secret')"
                >
                </el-input>
              </el-form-item>
            </div>

            <!-- iOS -->
            <div class="dis-flex">
              <!-- appID -->
              <el-form-item
                class="title_item   m-bottom-24"
                prop="iosAppId"
                label-width="220px"
                :label="$t('label.location.iOS')"
              >
                <el-input
                  maxlength="32"
                  class="show-word-limt-input-padding-right-52"
                  style="width: 356px"
                  v-model="dataInfo.iosAppId"
                  show-word-limit
                  :placeholder="$t('label.location.appID')"
                >
                </el-input>
              </el-form-item>

              <!-- Secret -->
              <el-form-item
                class="title_item m-bottom-24 m-left-16"
                prop="iosSecret"
              >
                <el-input
                  maxlength="32"
                  class="show-word-limt-input-padding-right-52"
                  style="width: 356px"
                  v-model="dataInfo.iosSecret"
                  show-word-limit
                  :placeholder="$t('label.location.secret')"
                >
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <loading-dialog :dialogVisible="showLoading" />
    </div>
    <!--  body end  -->
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout";
import SystemManageApi from "@/api/SystemManageApi";
import headTitle from "@/components/common/head/head";
import narrowDown from "@/components/common/generalButton/NarrowDown";
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import Menubar from "@/components/leftmenu/DashBoard";
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import SpSmartButton from "@/components/common/sp-smart-button";

export default {
  name: "MeetingRoomDetail",
  components: {
    MainLayout: MainLayout,
    headTitle: headTitle,
    LoadingDialog: LoadingDialog,
    narrowDown: narrowDown,
    Menubar: Menubar,
    SpSmartButton: SpSmartButton
  },
  data() {
    return {
      orgId: null,
      ownerDetail:null,
      dataInfo: {
        customerName: null,
        customerId: null,
        subscriptionKey: null,
        webAppId: null,
        webSecret: null,
        androidAppId: null,
        androidSecret: null,
        iosAppId: null,
        iosSecret: null,
        guidStatus: false,
      },
      showLoading: false,
      rules: {
        customerName: [
          {
            max: 20,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t('label.location.customerName'),
              length: 20
            })
          },
        ],
        customerId: [
          {
            max: 8,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.customerId"),
              length: 8
            })
          },
          {
            pattern: /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.customerId"),
              type: '半角英数字'
            })
          }
        ],
        subscriptionKey: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.subscriptionKey"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.subscriptionKey"),
              type: '半角英数字'
            })
          }
        ],
        webAppId: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.web") + this.$t("label.location.appID"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.web") + this.$t("label.location.appID"),
              type: '半角英数字'
            })
          }
        ],
        webSecret: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.web") + this.$t("label.location.secret"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.web") + this.$t("label.location.secret"),
              type: '半角英数字'
            })
          }
        ],
        androidAppId: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.android") + this.$t("label.location.appID"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.android") + this.$t("label.location.appID"),
              type: '半角英数字'
            })
          }
        ],
        androidSecret: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.android") + this.$t("label.location.secret"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.android") + this.$t("label.location.secret"),
              type: '半角英数字'
            })
          }
        ],
        iosAppId: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.iOS") + this.$t("label.location.appID"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.iOS") + this.$t("label.location.appID"),
              type: '半角英数字'
            })
          }
        ],
        iosSecret: [
          {
            max: 32,
            trigger: 'change',
            message: this.$t('message.common.validation.size', {
              field: this.$t("label.location.iOS") + this.$t("label.location.secret"),
              length: 32
            })
          },
          {
            pattern:  /^[A-Za-z0-9]*$/,
            trigger: 'change',
            message: this.$t('message.common.validation.type', {
              field: this.$t("label.location.iOS") + this.$t("label.location.secret"),
              type: '半角英数字'
            })
          }
        ],
      }
    };
  },
  methods: {

    //位置用Mapxus接続情報取得
    getDataInfo() {
      this.showLoading = true
      SystemManageApi.getLocationMapxusInfo(
        this.orgId
      )
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {

          // データある場合、「項目一覧」を参照して、レスポナス内容を画面に設定する
          if (data != null) {
            if(data.body.mapxusInfo){
              this.dataInfo.customerName = data.body.mapxusInfo.customerName;
              this.dataInfo.customerId = data.body.mapxusInfo.customerId;
              this.dataInfo.subscriptionKey = data.body.mapxusInfo.subscriptionKey;
              this.dataInfo.webAppId = data.body.mapxusInfo.webAppId;
              this.dataInfo.webSecret = data.body.mapxusInfo.webSecret;
              this.dataInfo.androidAppId = data.body.mapxusInfo.androidAppId;
              this.dataInfo.androidSecret = data.body.mapxusInfo.androidSecret;
              this.dataInfo.iosAppId = data.body.mapxusInfo.iosAppId;
              this.dataInfo.iosSecret = data.body.mapxusInfo.iosSecret;
            }
            this.dataInfo.guidStatus = data.body.guidStatus;
            this.showLoading = false;
            this.$nextTick(() => {
              this.$refs["formRef"].clearValidate();
            });
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    activateGUID() {
      this.isDialogConfirmComplete = true;
    },


    updateStatus() {

      let entries = Object.entries(this.dataInfo);

      let hasEmpty = entries
        .filter(([key]) => key !== 'guidStatus')
        .some(([, val]) => val == null || val == '');

      let isAllEmpty = entries
        .filter(([key]) => key !== 'guidStatus')
        .every(([, val]) => val == null || val == '');

      let hasBothEmptyAndNonEmpty = hasEmpty && !isAllEmpty;

      if(hasBothEmptyAndNonEmpty){
        this.$messageIotError(this.$t("message.common.ERR_RELATION_MSG"));
        return ;
      }

      // 「登録」ボタン押下時チェック
      this.$refs["formRef"].validate((valid) => {
        if(valid){
          this.showLoading = true
          // 「位置用Mapxus接続情報設定：管理」を呼び出す
          SystemManageApi.setLocationMapxusInfo(this.orgId, this.dataInfo)
          .then(({ data }) => {
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return
            }
            //正常 登録済みのメッセージを一時的に表示し、保存完了を提示します
            if (data.statusCode == "Success") {
              this.$messageIotSuccess(this.$t("label.location.editSaveSuccess"))
            }
            //遷移元画面「Mapxus管理情報」に遷移する
            this.mapxusManage();
          })
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .finally(() => {
            this.showLoading = false
          })
        }
      });

    },
    mapxusManage(){
      // 「Mapxus管理情報」に遷移する
      this.$router.push({
        name: "mapxus-manage-detail",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

  },
  created() {
    this.orgId = this.$route.query.orgId;
    this.ownerDetail = JSON.parse(this.$route.query.ownerDetail);
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.location.mapxusManage",
      }
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
  mounted() {
    this.getDataInfo();
  },
};
</script>

<style scoped lang="scss">
.info-area {
  display: flex;
  flex-direction: column;
}

.sub-title {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 20px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  color: #525250;
  margin-bottom: 24px;
  margin-top: 48px;
}

.width-50 {
  width: 50%;
}

.master-start {
  width: 1000px;
}

::v-deep .master-start > .el-form-item__label::after {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.title_item {
  ::v-deep .el-form-item__label::before {
    display: none;
  }

  ::v-deep .el-input__inner {
    width: 100%;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}
.m-bottom-24{
  margin-bottom: 24px;
}

.m-top-60{
  margin-top: 60px;
}

hr.delimiter {
  margin-top: 20px !important;
  margin-bottom: 40px !important;
  background-color: #D4D4D4 !important;
}

.sdk-content-style{
  width: 948px;
  display: flex;
  flex-direction: column;
}

.dis-flex{
  display: flex;
}
.sub-color{
  color: #525250;
}
.m-left-16{
  margin-left: 16px;
}
</style>
